import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { CosignatureSupervisors } from "@/core/types";
import { LONG_LIVED_CACHE } from "@/lib/constants/cache";

import { cosignatureKeys } from "../keyFactory";
import { getCosignatureSupervisors } from "../queryFunctions/getCosignatureSupervisors";

type UseCosignatureSupervisorsProps<TData = CosignatureSupervisors> = {
  enabled?: boolean;
  select?: (data: CosignatureSupervisors) => TData;
};

type CosignatureSupervisorsQueryOptions = UseQueryOptions<
  CosignatureSupervisors,
  unknown,
  CosignatureSupervisors,
  ReturnType<typeof cosignatureKeys.supervisors>
>;

function optionFactory(enabled = true) {
  return {
    enabled,
    queryFn: getCosignatureSupervisors,
    queryKey: cosignatureKeys.supervisors(),
    staleTime: LONG_LIVED_CACHE,
  } satisfies CosignatureSupervisorsQueryOptions;
}

export function useCosignatureSupervisors<TData = CosignatureSupervisors>({
  enabled = true,
  select,
}: UseCosignatureSupervisorsProps<TData> = {}) {
  return useQuery({ ...optionFactory(enabled), select });
}
